import React from 'react'
import { Outlet, Navigate } from 'react-router-dom'
import { useSelector } from 'react-redux';

// Diplay Pages according to user Logined or not
export default function PrivateRoute() {
    const currentuser = JSON.parse(localStorage.getItem('matrimonialAuthCredentials'))
    return currentuser ? <Outlet /> : <Navigate to="matrimonial" />;
}
